import Swiper from "swiper";
import * as $ from "jquery";
// import Plyr from "plyr";
import emergence from "emergence";
import "imagesLoaded";
// import "masonry";
import mixitup from "mixitup";
import cookie from "./cookie.umd.min";

$(function () {
  onLoad();
  $('main[role="main"]').on("homeLoaded", function () {
    loadHomepage();
  });
});

function getTitlesNav() {
  if ($("body").hasClass("single-convention")) {
    return $(".content-inner h2");
  } else if ($("body").hasClass("page-template-ccn")) {
    return $("h3.ccn-title-label");
  } else if ($("body").hasClass("search")) {
    return $(".search-group-title");
  } else {
    return $(".content-inner [data-anchor]").filter(function () {
      return $(this).closest(".encadre").length === 0;
    });
  }
}

function titlesNav(e) {
  // On vérifie de ne pas être sur une page CCN
  var $asidenav = $(".aside-navigation"),
    $jsasidenav = $(".js-aside-navigation"),
    $titlesnav = getTitlesNav();

  if (!$asidenav.length) {
    return;
  }

  if ($jsasidenav.length && $jsasidenav.html().trim() !== "") {
    return;
  }

  // Si le node est vide on affiche pas le bloc de navigation
  if ($titlesnav.length == 0) {
    $asidenav.hide();
  } else {
    $titlesnav.each(function () {
      var $this = $(this);
      // On exclue les titres dans les encadrés
      // Plus rapide que $this.parent().is(".accordeon, .encadre")
      if (
        !$this.parent().hasClass("accordeon") &&
        !$this.parent().hasClass("encadre") &&
        !$this.parent().hasClass("accordeon-inner")
      ) {
        $jsasidenav.append(
          '<li class="aside-navigation-item' +
          ($this.prop("tagName") === "H4" ? " aside-nav-item-small" : "") +
          '"><a href="#' +
          $this.data("anchor") +
          '" class="aside-navigation-link underline">' +
          $this.text() +
          "</a></li>"
        );
      }
    });
  }

  /*
        Système de navigation sidebar
    */

  $jsasidenav.on("click", ".aside-navigation-link", function (e) {
    e.preventDefault();

    var target = $(this).attr("href"),
      $target = $(target);

    if (!$target.length) {
      $target = $('[data-anchor="' + target.substr(1) + '"]');
    }

    if (!$target.length) {
      return;
    }

    var scrollTop = $target.offset().top - $("#header").height(),
      $adminbar = $("#wpadminbar");

    if ($adminbar.length) {
      scrollTop -= $adminbar.height();
    }

    var saveScrollTop = $(window).scrollTop();
    location.hash = target;
    $("html, body").scrollTop(saveScrollTop);

    $("html, body").stop().animate(
      {
        scrollTop: scrollTop,
      },
      600
    );

    return false;
  });
}

var doc = document.documentElement;
var w = window;

var prevScroll = w.scrollY || doc.scrollTop;
var curScroll;
var direction = 0;
var prevDirection = 0;

var header = document.getElementById("header");
var headerHeight = header.offsetHeight;

var checkScroll = function () {
  /*
   ** Find the direction of scroll
   ** 0 - initial, 1 - up, 2 - down
   */

  curScroll = w.scrollY || doc.scrollTop;
  if (curScroll > prevScroll) {
    //scrolled up
    direction = 2;
  } else if (curScroll < prevScroll) {
    //scrolled down
    direction = 1;
  }

  if (direction !== prevDirection) {
    toggleHeader(direction, curScroll);
  }

  prevScroll = curScroll;
};

var toggleHeader = function (direction, curScroll) {
  var $asidenav = $(".aside-navigation");
  if (direction === 2 && curScroll > headerHeight) {
    header.classList.add("hide");
    $asidenav.css("top", "6rem");
    prevDirection = direction;
  } else if (direction === 1) {
    header.classList.remove("hide");
    $asidenav.addClass("aside_with_menu");
    $asidenav.css("top", headerHeight);
    prevDirection = direction;
  }
};

window.addEventListener("scroll", checkScroll);

//Load js async
function async(script, callback) {
  var s = document.createElement('script'),
    head = document.getElementsByTagName('head')[0];
  s.type = "text/javascript";
  s.async = true;
  s.defer = true;
  s.src = script;
  if (typeof callback == 'function') { s.addEventListener('load', function (e) { callback.call(); }, false); }
  head.appendChild(s);
}

//Load css
function loadCSS(href, callback, media) {
  var doc = w.document;
  var ss = doc.createElement("link");
  var ref;
  var refs = (doc.body || doc.getElementsByTagName("head")[0]).childNodes;
  ref = refs[refs.length - 1];
  var sheets = doc.styleSheets;
  ss.rel = "stylesheet";
  ss.href = href;
  ss.media = "only x";
  ref.parentNode.insertBefore(ss, ref.nextSibling);
  var onloadcssdefined = function (cb) {
    var resolvedHref = ss.href;
    var i = sheets.length;
    while (i--) {
      if (sheets[i].href === resolvedHref) {
        return cb();
      }
    }
    setTimeout(function () {
      onloadcssdefined(cb);
    });
  };
  function loadCB() {
    if (ss.addEventListener) {
      ss.removeEventListener("load", loadCB);
    }
    ss.media = media || "all";
    if (typeof callback == 'function') {
      callback();
    }
  }
  if (ss.addEventListener) {
    ss.addEventListener("load", loadCB);
  }
  ss.onloadcssdefined = onloadcssdefined;
  onloadcssdefined(loadCB);
}

function plyrVideo() {
  const controls = [
    "play-large", // The large play button in the center
    "play", // Play/pause playback
    "progress", // The progress bar and scrubber for playback and buffering
    "current-time", // The current time of playback
    "duration", // The full duration of the media
    "mute", // Toggle mute
    "volume", // Volume control
    "fullscreen", // Toggle fullscreen
  ];

  const player = Plyr.setup(".js-player", {
    controls,
  });
}

function onLoad() {
  /*
        Launch video
     */
  // plyrVideo();
  var plyr_is_ready = false;
  var plyr_js_is_ready = false;
  var plyr_css_is_ready = false;
  var plyr_js_is_loading = false;
  var plyr_css_is_loading = false;

  function init_videos() {
    var vimeocallback = function () {
      video_load_plyr(".vimeo_player");
    };
    window.initvimeovideos = vimeocallback;

    var youtubecallback = function () {
      video_load_plyr(".youtube_player");
    };
    window.inityoutubevideos = youtubecallback;
    video_load_plyr();
  }

  init_videos();

  function video_load_plyr(filter) {
    var $videosIframesLoad = $(".js-player");
    if (filter)
      $videosIframesLoad = $videosIframesLoad.filter(filter);
    if (!$videosIframesLoad.length) return;

    if (plyr_is_ready) {
      plyrVideo();
      return;
    }

    if (!plyr_js_is_loading) {
      plyr_js_is_loading = true;
      async(url.theme + 'assets/js/lib/plyr.min.js', plyr_js_loaded);
    }
    if (!plyr_css_is_loading) {
      plyr_css_is_loading = true;
      loadCSS(url.theme + 'assets/css/lib/plyr.min.css', plyr_css_loaded);
    }
  }

  function plyr_js_loaded() {
    plyr_js_is_ready = true;
    check_plyr_is_ready();
  }

  function plyr_css_loaded() {
    plyr_css_is_ready = true;
    check_plyr_is_ready();
  }

  function check_plyr_is_ready() {
    if (!plyr_is_ready && plyr_js_is_ready && plyr_css_is_ready) {
      plyr_is_ready = true;
      plyrVideo();
    }
    return plyr_is_ready;
  }

  $(window).on("load.innovantsPage", function () {
    tarteaucitron.triggerJobsAfterAjaxCall();
    init_videos();
  });

  $(window).on("load.inclusionPage", function () {
    tarteaucitron.triggerJobsAfterAjaxCall();
    init_videos();
  });

  /*
        Cookies
     */
  tarteaucitronCustomText = {
    acceptAll: "Accepter",
    allowAll: "Accepter",
    denyAll: "Refuser",
    alertBigPrivacy:
      "Ce site utilise des cookies et vous donne le <br>contrôle sur ceux que vous souhaitez activer",
  };
  tarteaucitron.init({
    privacyUrl: "" /* Privacy policy url */,

    hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
    cookieName: "tarteaucitron" /* Cookie name */,

    orientation: "bottom" /* Banner position (top - bottom) */,

    showAlertSmall: false /* Show the small banner on bottom right */,
    cookieslist: false /* Show the cookie list */,

    showIcon: true /* Show cookie icon to manage cookies */,
    iconPosition:
      "BottomRight" /* BottomRight, BottomLeft, TopRight and TopLeft */,

    adblocker: false /* Show a Warning if an adblocker is detected */,
    closePopup: false /* Show a close X on the banner */,
    DenyAllCta: true /* Show the deny all button */,
    AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
    highPrivacy: true /* Disable auto consent */,

    handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

    removeCredit: true /* Remove credit link */,
    moreInfoLink: true /* Show more info link */,

    useExternalCss: true /* If false, the tarteaucitron.css file will be loaded */,
    useExternalJs: false /* If false, the tarteaucitron.js file will be loaded */,

    //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

    readmoreLink: "" /* Change the default readmore link */,

    mandatory: false /* Show a message about mandatory cookies */,
  });

  tarteaucitron.user.gtagUa = 'G-V3YZV1NZCL';
  (tarteaucitron.job = tarteaucitron.job || []).push('gtag');

  (tarteaucitron.job = tarteaucitron.job || []).push('youtube');

  tarteaucitron.user.googlemapsKey = "AIzaSyB3LNIjIH-4sHoup9Kvmapt10dUui44KrQ";
  tarteaucitron.user.mapscallback = "gmapcallback";
  (tarteaucitron.job = tarteaucitron.job || []).push("googlemaps");

  document.addEventListener("youtube_allowed", function (_) {
    window.inityoutubevideos();
  });
  document.addEventListener("youtube_added", function (_) {
    window.inityoutubevideos();
  });

  document.addEventListener("plyr_vimeo_allowed", function (_) {
    window.initvimeovideos();
  });
  document.addEventListener("plyr_vimeo_added", function (_) {
    window.initvimeovideos();
  });

  tarteaucitron.load();

  /*
        Header fixed up and down
    */

  /*
        Toggle menu desktop / mobile
    */
  $(".header-menu-nav").on("click", ".js-toggle-menu", function () {
    var $menuWrapper = $(this).siblings(".header-menu-mega-wrapper");

    // Menu mobile
    if ($(window).width() <= 1130) {
      var curHeight = $menuWrapper.height();
      var autoHeight = $menuWrapper.css("height", "auto").height();

      // Si le menu est actif, on le ferme
      if ($menuWrapper.hasClass("active")) {
        $menuWrapper.height(curHeight).animate(
          {
            height: 0,
          },
          250
        );
        $menuWrapper.removeClass("active");
        // On ouvre le menu
      } else {
        $menuWrapper.height(curHeight).animate(
          {
            height: autoHeight,
          },
          250,
          function () {
            $menuWrapper.addClass("active");
          }
        );
      }
      // Menu desktop
    } else {
      $menuWrapper.toggleClass("active");

      $(".header-menu-mega-wrapper").each(function (index, el) {
        var $el = $(el);

        if (el !== $menuWrapper.get(0)) {
          $el.removeClass("active");
        }
      });

      if ($(".header-menu-mega-wrapper").hasClass("active")) {
        $("body").addClass("overflow-hidden");
      } else {
        $("body").removeClass("overflow-hidden");
      }
    }
  });

  /*
        Ouvrir le menu mobile
    */
  $(".header-menu").on("click", ".js-open-menu-mobile", function () {
    $(".header-menu").addClass("active");
    $("body").addClass("overflow-hidden");
    $(".js-close-menu-mobile").toggleClass("active");
  });

  /*
        Fermer le menu mobile
    */
  $(".header-menu").on("click", ".js-close-menu-mobile", function () {
    $(".header-menu").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".js-close-menu-mobile").toggleClass("active");
  });

  /*
        Ouvrir la search
    */
  $(".header").on("click", ".js-open-live-search", function () {
    $(".header-menu-mega-wrapper.active").removeClass("active");
    $(".live-search-desktop").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  /*
        Fermer la search
    */
  $(".header").on("click", ".js-close-live-search", function () {
    $(".live-search-desktop").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  /*
        Recherche ajax
    */
  var ajax_search;
  $(".live-search-input input").on("input", function () {
    if (!$(".live-search-result").is(":visible")) {
      return;
    }
    if (ajax_search) {
      ajax_search.abort();
    }
    ajax_search = $.ajax({
      url: url.ajax,
      type: "GET",
      dataType: "html",
      data: { action: "live_search", s: $(this).val() },
    })
      .done(function (data) {
        $(".live-search-result").html(data);
      })
      .fail(function () { })
      .always(function () { });
  });

  /*
        Chargement actualités en ajax
    */
  var $actus_wrapper = $(".article-ajax");
  if ($actus_wrapper.length && typeof actus !== "undefined") {
    var actus_next_cache;
    var actus_prev_cache;
    var last_scroll = 0;
    var is_loading = 0; // simple lock to prevent loading when loading
    var hide_on_load = false; // ID that can be hidden when content has been loaded

    function actus_load_next() {
      if (actus.next != "") {
        is_loading = 1; // note: this will break when the server doesn't respond

        function actus_show_next(data) {
          $(".article-item:last").after(data.response);
          actus.next = data.next;
          actus_next_cache = false;
          $.ajax({
            dataType: "json",
            url: url.ajax,
            data: {
              action: "load_more_news",
              page: actus.next,
              cat: actus.cat,
            },
            success: function (preview_data) {
              actus_next_cache = preview_data;
            },
          });
        }

        if (actus_next_cache) {
          actus_show_next(actus_next_cache);
          is_loading = 0;
        } else {
          $.ajax({
            dataType: "json",
            url: url.ajax,
            data: {
              action: "load_more_news",
              page: actus.next,
              cat: actus.cat,
            },
            success: function (data) {
              actus_show_next(data);
              is_loading = 0;
            },
          });
        }
      }
    }

    function actus_load_prev() {
      if (actus.prev != "") {
        is_loading = 1; // note: this will break when the server doesn't respond

        function actus_show_prev(data) {
          var scrollTop = $(window).scrollTop();
          $(".article-item:first").before(data.response);
          $('.article-item[data-page="' + data.curr + '"]').each(function () {
            scrollTop += $(this).outerHeight(true);
          });
          window.scrollTo(0, scrollTop);
          actus.prev = data.prev;
          actus_prev_cache = false;
          $.ajax({
            dataType: "json",
            url: url.ajax,
            data: {
              action: "load_more_news",
              page: actus.prev,
              cat: actus.cat,
            },
            success: function (preview_data) {
              actus_prev_cache = preview_data;
            },
          });
          if (hide_on_load) {
            $(hide_on_load).hide();
            hide_on_load = false;
          }
        }
        if (actus_prev_cache) {
          actus_show_prev(actus_prev_cache);
          is_loading = 0;
        } else {
          $.ajax({
            dataType: "json",
            url: url.ajax,
            data: {
              action: "load_more_news",
              page: actus.prev,
              cat: actus.cat,
            },
            success: function (data) {
              actus_show_prev(data);
              is_loading = 0;
            },
          });
        }
      }
    }

    function mostlyVisible(element) {
      // if ca 25% of element is visible
      var scroll_pos = $(window).scrollTop();
      var window_height = $(window).height();
      var el_top = $(element).offset().top;
      var el_height = $(element).height();
      var el_bottom = el_top + el_height;
      return (
        el_bottom - el_height * 0.25 > scroll_pos &&
        el_top < scroll_pos + 0.5 * window_height
      );
    }

    function primeCache() {
      if (actus.prev) {
        $.ajax({
          dataType: "json",
          url: url.ajax,
          data: {
            action: "load_more_news",
            page: actus.prev,
            cat: actus.cat,
          },
          success: function (data) {
            actus_prev_cache = data;
          },
        });
      }

      if (actus.next) {
        $.ajax({
          dataType: "json",
          url: url.ajax,
          data: {
            action: "load_more_news",
            page: actus.next,
            cat: actus.cat,
          },
          success: function (data) {
            actus_next_cache = data;
          },
        });
      }
    }
    primeCache();

    $(window).on("scroll", function () {
      // handle scroll events to update content
      var scroll_pos = $(window).scrollTop();
      var $last = $(".article-item:last");
      var $first = $(".article-item:first");
      if (scroll_pos >= $last.offset().top - $(window).height()) {
        if (is_loading == 0) actus_load_next();
      }
      if (scroll_pos <= $first.offset().top + $first.height()) {
        if (is_loading == 0) actus_load_prev();
      }
      // Adjust the URL based on the top item shown
      // for reasonable amounts of items
      if (Math.abs(scroll_pos - last_scroll) > $(window).height() * 0.1) {
        last_scroll = scroll_pos;
        $(".article-item").each(function (index) {
          if (mostlyVisible(this)) {
            var page = $(this).attr("data-page");
            actus.current = page;
            history.replaceState(
              null,
              null,
              actus.url + (page > 1 ? "page/" + page + "/" : "")
            );
            // $("#pagination").html($(this).attr("data-pagination"));
            return false;
          }
        });
      }
    });

    $(".article-pagination").hide();

    // if we have enough room, load the next batch
    if ($(window).height() > $actus_wrapper.height()) {
      if (actus.next != "") {
        actus_load_next();
      } else {
        // console.log( 'filler' );
        // var filler = document.createElement("div");
        // filler.id = "filler";
        // filler.style.height = ($(window).height() -
        //         $actus_wrapper.height())+ "px";
        //
        // console.log( filler.style.height );
        // $actus_wrapper.after(filler);
        // hide_on_load = "filler";
      }
    }
    // scroll down to hide empty room
    head_height = $("#header").outerHeight(true) + $(".hero").outerHeight(true);

    if (actus.prev != "") {
      $(window).scrollTop(head_height);
    }
  }

  /*
        Toggle les filtres sur le listing d'actualités
    */
  $(".article-list").on("click", ".js-toggle-filter", function () {
    $(".article-filter-list").toggle();
  });

  /*
        Si nous sommes sur la page template convention
        On initialise mixitup
    */
  if ($("body").hasClass("page-template-ccn")) {
    var hash = window.location.hash.substr(1);

    if (hash) {
      $('[data-anchor="' + hash + '"]').each(function () {
        $("html, body").scrollTop(0);
        var label = $(this);
        var topValue = label.offset().top - 30;
        $("html, body").animate({ scrollTop: topValue }, "slow");
      });
    }

    // Load mixitup plugin
    var mixer = mixitup(".ccn-accord");

    // Toggle les thématiques sur les accords
    $(".js-toggle-thematique").on("click", function () {
      $(".ccn-thematique-filter").toggle();
    });

    // Si on est sur la page de la convention qu’on clique dans le menu
    $(".subnav").on("click", "a", function (e) {
      var hash = e.currentTarget.hash.substr(1);

      if (/#/.test(this.href)) {
        var label = $('.list-item-label[data-anchor="' + hash + '"]');

        if (label.length == 0) {
          return;
        }

        if ($(window).width() > 1131) {
          $(".header-menu-mega-wrapper").removeClass("active");
          $("body").removeClass("overflow-hidden");
        } else {
          $(".header-menu-mega-wrapper").removeClass("active");
          $(".header-menu").removeClass("active");
          $("body").removeClass("overflow-hidden");
          $(".js-close-menu-mobile").toggleClass("active");
        }

        var topValue = label.offset().top - 30;
        $("html, body").animate({ scrollTop: topValue }, "slow");

        return false;
      }
    });
  }

  /*
        Toggle accordéon
    */
  $(".js-accordeon-toggle").on("click", function (e) {
    if (!$(this).closest(".accordeon").hasClass("is-active")) {
      $(this).closest(".accordeon").addClass("is-active");
      var el = $(this).closest(".accordeon").find(".accordeon-body");
      var curHeight = el.height();
      var autoHeight = el.css("height", "auto").height();
      el.height(curHeight).animate(
        {
          height: autoHeight,
          marginTop: 20,
        },
        250
      );
    } else {
      // On ferme l’accordeon
      $(this).closest(".accordeon").removeClass("is-active");
      $(this).closest(".accordeon").find(".accordeon-body").animate(
        {
          height: 0,
          marginTop: 0,
        },
        250
      );
    }
    e.preventDefault();
  });

  /*
        Si nous sommes sur la page template des outils
        On ouvre l’accordeon correspondant a l’ancre de l’url
    */
  if ($("body").hasClass("page-template-tools")) {
    var hash = window.location.hash.substr(1);

    if (hash) {
      $('.accordeon-toggle[data-anchor="' + hash + '"]').each(function () {
        var accordeon = $(this);
        var el = accordeon.closest(".accordeon").find(".accordeon-body");
        var curHeight = el.height();
        var autoHeight = el.css("height", "auto").height();
        var topValue = accordeon.offset().top - 30;
        el.height(curHeight).animate(
          {
            height: autoHeight,
            marginTop: 20,
          },
          250
        );
        accordeon.closest(".accordeon").toggleClass("is-active");
        $("html, body").animate({ scrollTop: topValue }, "slow");
      });
    }

    // Si on est sur la page des outils et qu’on clique dans le menu
    $(".subnav").on("click", "a", function (e) {
      var hash = e.currentTarget.hash.substr(1);

      if (/#/.test(this.href)) {
        var accordeon = $(".accordeon-toggle[data-anchor=" + hash + "]");

        if (accordeon.length == 0) {
          return;
        }

        if ($(window).width() > 1131) {
          $(".header-menu-mega-wrapper").removeClass("active");
          $("body").removeClass("overflow-hidden");
        } else {
          $(".header-menu-mega-wrapper").removeClass("active");
          $(".header-menu").removeClass("active");
          $("body").removeClass("overflow-hidden");
          $(".js-close-menu-mobile").toggleClass("active");
        }

        var el = accordeon.closest(".accordeon").find(".accordeon-body");
        var curHeight = el.height();
        var autoHeight = el.css("height", "auto").height();
        var topValue = accordeon.offset().top - 30;
        el.height(curHeight).animate(
          {
            height: autoHeight,
            marginTop: 20,
          },
          250
        );
        accordeon.closest(".accordeon").toggleClass("is-active");
        $("html, body").animate({ scrollTop: topValue }, "slow");

        return false;
      }
    });
  }

  titlesNav();
  $(window).on("load.inclusionPage", titlesNav);

  /*
        Slider des outils sur la homepage

    */
  if ($("body").hasClass("home")) {
    loadHomepage();
    //$('.js-slider-tools').html( $('.js-slider-tools').html() + $('.js-slider-tools').html() );
  }

  /*
        Slider des podcast

    */

  loadPodcast();
  $(window).on("load.inclusionPage", loadPodcast);

  /*
        Smooth scroll
    */
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.trigger("focus");
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.trigger("focus"); // Set focus again
              }
            }
          );
        }
      }
    });

  /*
        Définis le lien actif dans la navigation latérale
    */
  var onMainScroll = function () {
    if ($(this).get(0) === window) {
      var scrollDistance = $(this).scrollTop();
    } else {
      var scrollDistance = 0;
    }

    // var scrollDistance = $(this).scrollTop(),
    var $adminbar = $("#wpadminbar"),
      $titlesnav = getTitlesNav();

    if ($adminbar.length) {
      scrollDistance += $adminbar.height();
    }

    $titlesnav.each(function () {
      var thisOffset = $(this).offset().top - 20;
      if (thisOffset <= scrollDistance && $(this).prop("tagName") === "H3") {
        $(".aside-navigation-item:not(.aside-nav-item-small)")
          .find("a.active")
          .removeClass("active");
        var thisId = $(this).attr("id");
        $('a.aside-navigation-link[href="#' + thisId + '"]')
          .addClass("active")
          .parent()
          .prevAll()
          .find("a.active")
          .removeClass("active");
      }
      if ($(this).prop("tagName") === "H4") {
        if (thisOffset <= scrollDistance) {
          $(".aside-navigation-item.aside-nav-item-small")
            .find("a.active")
            .removeClass("active");
          var thisId = $(this).attr("id");
          $('a.aside-navigation-link[href="#' + thisId + '"]').addClass("active");
        } else {
          var thisId = $(this).attr("id");
          $('a.aside-navigation-link[href="#' + thisId + '"]').removeClass("active");
        }
      }
    });

    $(".aside-navigation-item").each(function (idx, el) {
      var $this = $(this);

      if (
        $this.hasClass("aside-nav-item-small") &&
        $this
          .prevAll(".aside-navigation-item:not(.aside-nav-item-small)")
          .first()
          .find("a")
          .hasClass("active")
      ) {
        $this.find("a").addClass("parent-active");
      } else {
        $this.find("a").removeClass("parent-active");
      }
    });
  };

  $(window)
    .add(".inclusion-wrapper")
    .on("scroll", onMainScroll)
    .trigger("scroll");

  //Accordéon indice syntec > historique
  $(".js-acc2").each(function (index, el) {
    var $cont = $(el);
    var $title = $cont.prev();
    $title.wrapInner('<button type="button"></button>');
    $cont.hide();
    $title
      .addClass("js-acc2-init")
      .find("button")
      .on("click", function (event) {
        event.preventDefault();
        $cont.slideToggle(300);
        $title.toggleClass("is-open");
      });
  });
  // Accordéons RSE
  $(".single-guide_rse .accordeon").each(function (index, el) {
    var $acc = $(el);
    var $title = $acc.children().first();
    var $cont = $acc.find(".accordeon-inner");
    $title.wrapInner('<button type="button"></button>');
    $cont.hide();
    $title
      .addClass("rse-accordeon")
      .find("button")
      .on("click", function (event) {
        event.preventDefault();
        $cont.slideToggle(250);
        $title.toggleClass("is-open");
      });
  });
  // Accordéons guides outil
  $(".single-outil_guide .accordeon").each(function (index, el) {
    var $acc = $(el);
    var $title = $acc.children().first();
    var $cont = $acc.find(".accordeon-inner");
    $title.wrapInner('<button type="button"></button>');
    $cont.hide();
    $title
      .addClass("outil-accordeon")
      .find("button")
      .on("click", function (event) {
        event.preventDefault();
        $cont.slideToggle(250);
        $title.toggleClass("is-open");
      });
  });

  //Formulaire recueil indice
  $("input[data-alert-ratio][data-alert-value]").each(function (index, el) {
    var $input = $(el);
    var ratio = parseFloat($input.attr("data-alert-ratio"));
    var valueRef = parseInt($input.attr("data-alert-value"));
    var valMax = valueRef * ratio;
    var valMin = valueRef / ratio;
    $input
      .on("input", function (event) {
        var val = this.value;
        val = val !== "" ? parseInt(val) : false;
        if (val === false || (val <= valMax && val >= valMin)) {
          $input.parent().removeClass("is-invalid");
        } else {
          $input.parent().addClass("is-invalid");
        }
        if ($input.closest("form").find(".is-invalid").length) {
          $input
            .closest("form")
            .find('[name="commentaires"]')
            .attr("required", true);
        } else {
          $input
            .closest("form")
            .find('[name="commentaires"]')
            .removeAttr("required");
        }
      })
      .trigger("input");
  });

  //Ratio dynamique
  $(".recueil [data-old-ratio]").each(function (index, el) {
    var $el = $(el);
    var oldRatio = parseFloat($el.attr("data-old-ratio"));
    var $msInput = $("#form_indice_ms");
    var $etpInput = $("#form_indice_etp");
    $msInput
      .add($etpInput)
      .on("input", function (event) {
        var newMS = parseFloat($msInput.val());
        var newETP = parseFloat($etpInput.val());
        var newRatio = newMS && newETP ? newMS / newETP : 0;
        if (newRatio) {
          $el.text(
            number_format(100 * (newRatio / oldRatio - 1), 2, ",", " ") + " %"
          );
        } else {
          $el.text("-");
        }
      })
      .trigger("input");
  });

  //Fonction js comme php number_format
  function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
    var dec = typeof decPoint === "undefined" ? "." : decPoint;
    var s = "";
    var toFixedFix = function (n, prec) {
      if (("" + n).indexOf("e") === -1) {
        return +(Math.round(n + "e+" + prec) + "e-" + prec);
      } else {
        var arr = ("" + n).split("e");
        var sig = "";
        if (+arr[1] + prec > 0) {
          sig = "+";
        }
        return (+(
          Math.round(+arr[0] + "e" + sig + (+arr[1] + prec)) +
          "e-" +
          prec
        )).toFixed(prec);
      }
    };
    s = (prec ? toFixedFix(n, prec).toString() : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  }

  /*
        Track pdf clicks
    */
  $('a[href$=".pdf"]')
    .filter(
      'a[href^="' + url.home + 'guide/"],a[href^="' + url.home + 'fiche/"]'
    )
    .on("click", function (event) {
      event.preventDefault();
      var urlfile = $(this).attr("href");
      var filename = new String(urlfile).substring(
        urlfile.lastIndexOf("/") + 1
      );
      var type = "fiche";
      if ($(this).is('a[href^="' + url.home + 'guide/"]')) {
        type = "guide";
      }
      if (typeof ga !== "undefined") {
        // console.log('ga');
        ga("send", "event", "pdf", type, filename);
      } else if (typeof _trackEvent !== "undefined") {
        // console.log('_trackEvent');
        _trackEvent("pdf", type, filename);
      } else if (typeof gtag !== "undefined") {
        // console.log('gtag');
        gtag("event", type, {
          event_label: filename,
          event_category: "pdf",
        });
      }
    });

  emergence.init({
    reset: false,
  });
  emergence.engage();
}

function loadHomepage() {
  var swiper = new Swiper(
    ".swiper-container:not(.swiper-container-initialized)",
    {
      slidesPerView: "auto",
      spaceBetween: 20,
      freeMode: true,
      navigation: {
        nextEl: ".tools-list-arrow-next",
        prevEl: ".tools-list-arrow-prev",
      },
      breakpoints: {
        1210: {
          spaceBetween: 30,
        },
        1230: {
          spaceBetween: 40,
        },
        1250: {
          spaceBetween: 50,
        },
      },
    }
  );

  // var $social = $(".js-social-list").masonry({
  //   itemSelector: ".js-social-item",
  //   columnWidth: ".js-social-sizer",
  //   percentPosition: true,
  // });
  // $social.imagesLoaded().progress(function () {
  //   $social.masonry("layout");
  // });
  emergence.init({
    reset: false,
  });
  emergence.engage();
}

function loadPodcast() {
  if (
    $("body").hasClass("single-podcast") ||
    $("body").hasClass("page-template-template-landing_inclusion") ||
    $("body").hasClass("single-guide_inclusion")
  ) {
    var swiper = new Swiper(
      ".swiper-container:not(.swiper-container-initialized)",
      {
        slidesPerView: "auto",
        spaceBetween: 24,
        allowTouchMove: true,
        breakpoints: {
          928: {
            slidesPerView: 3,
            spaceBetween: 65,
          },
        },
      }
    );
  }
}

jQuery.fn.shuffle = function () {
  var j;
  for (var i = 0; i < this.length; i++) {
    j = Math.floor(Math.random() * this.length);
    $(this[i]).before($(this[j]));
  }
  return this;
};

function loadTemoignages() {
  if ($("body").hasClass("page-template-template-landing-adhesion")) {
    $('.temoignage').shuffle();
    // var syndicats = [];
    // $('.temoignage').each(function(){
    //   var syndicat = $(this).attr('data-syndicat');
    //   if ( syndicats.length > 0 && $.inArray( syndicat, syndicats ) > -1 ) { $(this).remove(); }
    //   else { syndicats.push( syndicat ); }
    // });
    // $('.temoignage').shuffle();

    const setTemoignagesArrows = function () {
      var slideWidth = $("body").find('.temoignage.swiper-slide-active').first().outerWidth();
      var arrow_temoignage = $("body").find('.temoignage_arrow');
      arrow_temoignage.css('width', parseInt(slideWidth) + 70 + 'px');
    }

    var swiper = new Swiper(
      ".swiper-container:not(.swiper-container-initialized)",
      {
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 5,
        // width: "auto",
        navigation: {
          nextEl: ".temoignage_arrow-next",
          prevEl: ".temoignage_arrow-prev",
        },
        speed: 800,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          scale: 1,
          slideShadows: true,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 10,
            slidesPerView: 1.2,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: 1.4,
          },
          1440: {
            spaceBetween: 25,
            slidesPerView: 2,
          },
        },
        on: {
          init: setTemoignagesArrows,
          resize: setTemoignagesArrows
        }
      }
    );

  }
}
loadTemoignages();

function loadModale() {
  var $window = $(window),
    $body = $('body'),
    $smartbar = $('#smartbar'),
    $overlay = $('.overlay'),
    $smartbar_close = $smartbar.find('.smartbar-close'),
    smartbar_display = function () {
      if (cookie.get('hide-smartbar')) {
        return;
      }
      // var smartbarH = $smartbar.outerHeight();
      $body.addClass('show-smartbar');
    };

  smartbar_display();

  $window.on('load resize', smartbar_display);

  $window.on('load', function () {
    cookie.set('hide-smartbar', 4, { path: '/' });
  });

  $smartbar_close.on('click', function () {
    $body.addClass('hide-smartbar');
    $body.removeClass('show-smartbar');
    $('#cookie-law-info-bar').css('bottom', 0);
    // cookie.set('hide-smartbar', 1, { path: '/' });
  });

  $overlay.on('click', function () {
    $body.addClass('hide-smartbar');
    $body.removeClass('show-smartbar');
    $('#cookie-law-info-bar').css('bottom', 0);
    // cookie.set('hide-smartbar', 1, { path: '/' });
  });
}
loadModale();

import './innovants';
import './inclusion';
